export default "__VITE_ASSET__xXQ7Pqy9__"